export type OnboardingFormReference = {
  uuid?: string;
  formType?: string;
  isCompleted?: boolean;
  updatedAt?: string;
};

const getUpdatedAtTimestamp = ({ updatedAt }: OnboardingFormReference) => {
  if (!updatedAt) return Number.NEGATIVE_INFINITY;

  const timestamp = new Date(updatedAt).getTime();
  return Number.isNaN(timestamp) ? Number.NEGATIVE_INFINITY : timestamp;
};

export const selectSingletonForm = (
  onboardingForms: OnboardingFormReference[],
  formType: string
) => {
  const matchingForms = onboardingForms.filter(
    (form) => form.formType === formType
  );

  if (matchingForms.length <= 1 || !formType.startsWith('QUICK_WIN_')) {
    return matchingForms[0];
  }

  console.warn('[Onboarding] Duplicate QUICK_WIN singleton forms detected', {
    formType,
    forms: matchingForms.map(({ uuid, isCompleted, updatedAt }) => ({
      uuid,
      isCompleted,
      updatedAt,
    })),
  });

  const completedForms = matchingForms.filter(
    ({ isCompleted }) => isCompleted === true
  );
  const candidates = completedForms.length > 0 ? completedForms : matchingForms;

  return candidates.reduce((selected, candidate) =>
    getUpdatedAtTimestamp(candidate) > getUpdatedAtTimestamp(selected)
      ? candidate
      : selected
  );
};
